// @mui

import i18n from 'i18';
import config from 'config';
import helper from 'utils/helper';
import { MenuItem, Typography, Select } from '@mui/material';
// ----------------------------------------------------------------------

export default function LanguagePopover() {
    const langs = config.languages;

    const selectedLanguage =
        langs.find((l) => l === i18n.resolvedLanguage) ||
        langs.find((l) => l === config.language);

    return (
        <Select
            value={selectedLanguage}
            onChange={(e) => helper.changeLanguage(e.target.value)}
            sx={{
                '& .MuiSelect-select': {
                    paddingTop: '4px',
                    paddingBottom: '4px'
                }
            }}
        >
            {langs.map((lang) => (
                <MenuItem key={lang} value={lang}>
                    <Typography variant="subtitle2">
                        {i18n.t(`langs.${lang}`)}
                    </Typography>
                </MenuItem>
            ))}
        </Select>
        
    );
}
